import { render, staticRenderFns } from "./input-validation.vue?vue&type=template&id=37c3eebd&"
import script from "./input-validation.vue?vue&type=script&lang=js&"
export * from "./input-validation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports